
export {} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$empty-state.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$empty-state.js';export default __x__;